module.exports = ".right {\n  display: flex !important; }\n"